












































import Vue from "vue";
import { InvoiceApi, VueTableRequest, InvoiceFileType } from "@/api";
import stateMixin from "@/mixins/state";
import { formatCurrency } from "@/util/currency";
import { downloadDocument } from "@/util/download";
import { saveAs } from "file-saver";

export default Vue.extend({
  data() {
    return {
      data: {},
      headers: [
        { text: "Jaar / Maand", value: "processedMonth" },
        { text: "Bedrag", value: "invoiceAmount", width: 200, align: "right" },
        { text: "", sortable: false, value: "actions", width: 100 }
      ],
      options: {
        sortBy: ["processedMonth"],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 20
      }
    };
  },
  name: "Invoices",
  mixins: [stateMixin],
  methods: {
    formatCurrency,
    fetch: async function() {
      this.setState(this.states.LOADING);
      const api = new InvoiceApi();
      try {
        const request: VueTableRequest = {
          sortBy: this.options.sortBy,
          descending: this.options.sortDesc,
          page: this.options.page,
          rowsPerPage: this.options.itemsPerPage,
          search: ""
        };
        const { data } = await api.invoiceGetInvoiceTable(request);
        this.data = data;
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    },
    downloadInvoice: async function(item: any, fileType: InvoiceFileType) {
      const api = new InvoiceApi();
      const { data, headers } = await api.invoiceDownloadInvoiceFile(
        item.processedMonth,
        item.clientCode,
        fileType,
        {
          responseType: "arraybuffer"
        }
      );
      let fileName = `${fileType}.pdf`;
      if (fileType === "Excel" || fileType === "ExcelDetails") {
        fileName = `${fileType}.xlsx`;
      }

      downloadDocument(data, headers);
    }
  },
  watch: {
    options: {
      handler() {
        this.fetch();
      },
      deep: true,
      immediate: false
    }
  }
});
